/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

/** @see backend/nexus/modules/Billing/Enum/PreferredPaymentMethod.php */
export const preferredPaymentMethod = {
	stripe: 'stripe',
	invoice: 'invoice',
} as const

/** @see backend/nexus/modules/Billing/Enum/PreferredPaymentMethod.php */
export type PreferredPaymentMethod = (typeof preferredPaymentMethod)[keyof typeof preferredPaymentMethod]
